import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { randomId } from '~/helpers/randomId';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzSidebar',
  props: {
    position: {
      default: 'right'
    }
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var slots = useSlots();
    var sidebar = ref(null);
    expose({
      sidebar: sidebar
    });
    var ariaId = "sidebar-".concat(randomId());

    /**
     * Closes the sidebar.
     */
    function closeSidebar() {
      emit('close', sidebar.value.returnValue);
      sidebar.value.close();
    }

    /**
     * Handles closing the sidebar when clicking outside it
     *
     * @param      {Event}  event   The event
     */
    function clickOutside(event) {
      if (event.target === sidebar.value && sidebar.value.open) {
        closeSidebar();
      }
    }
    onMounted(function () {
      sidebar.value.addEventListener('click', clickOutside);
    });
    onBeforeUnmount(function () {
      sidebar.value.removeEventListener('click', clickOutside);
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      slots: slots,
      sidebar: sidebar,
      ariaId: ariaId,
      closeSidebar: closeSidebar,
      clickOutside: clickOutside,
      AzIcon: AzIcon
    };
  }
});